/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const YoutubeFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12.24 4c.54 0 1.87.02 3.3.07l.5.02c1.43.07 2.86.19 3.56.39a2.8 2.8 0 0 1 1.94 2.02c.4 1.56.45 4.6.46 5.34v.32c0 .74-.06 3.78-.46 5.34a2.8 2.8 0 0 1-1.94 2.02c-.7.2-2.13.32-3.56.38l-.5.03c-1.43.05-2.76.07-3.3.07h-.49c-1.13 0-5.85-.06-7.36-.48a2.8 2.8 0 0 1-1.93-2.02c-.4-1.56-.45-4.6-.46-5.34v-.32c0-.74.06-3.78.46-5.34a2.8 2.8 0 0 1 1.93-2.02C5.9 4.06 10.62 4 11.75 4zM10 8.5v7l6-3.5z" />
  </Icon>
);
